/**
 * Csv Schema of CargaResponsavel
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaResponsavel} from '@/model/resource/CargaResponsavel'

/* TODO: review generated schema */
export class CsvCargaResponsavelSchema extends Schema {
  readonly name = 'CsvCargaResponsavel'

  readonly fieldSet: FieldSet<CargaResponsavel> = {
    ehEmbarcador: schema => Helper.bool(schema.model.ehEmbarcador),
    carga: schema => schema.model.carga?.$id ?? null,
    endereco: schema => schema.model.endereco?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    responsavelFilial: schema => schema.model.responsavelFilial?.$id ?? null,
    inscricaoEstadual: schema => schema.model.inscricaoEstadual,
    substitutoTributario: schema => schema.model.substitutoTributario,
    inscricaoMunicipal: schema => schema.model.inscricaoMunicipal,
    municipioIcms: schema => schema.model.municipioIcms,
    cnaeFiscal: schema => schema.model.cnaeFiscal,
    codigoRegimeTributario: schema => schema.model.codigoRegimeTributario,
  }
}
